const style = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 10,
  },
  formControlContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    gap: 10,
  },
  formControl: {
    marginLeft: 10,
  },
  button: {
    marginTop: 10,
  },
  formLabel: {
    color: '#647886',
    fontSize: 12,
    fontFamily: 'Roboto',
    marginBottom: 5,
  },
};

export default style;
